import React, {useState} from 'react';
import {LoadingWrapper} from "../Components/LoadingWrapper";
import SelectDropdown from "../Components/Dropdowns/SelectDropdown";
import {makeApiCall} from "../../Api/makeApiCall";
import AirflowDagLogs from "../Components/airflow/dagLogs/AirflowDagLogs";
import ButtonLoader from "../../utils/components/ButtonLoader";
import {invokeDAGviaApiPost} from "../../Api/invokeDag";
import _ from "lodash";

const StacklineDataUnload = () => {

    const DAG_ID_TO_TRIGGER_FOR_SALES = "acquire_stackline_sales_data_snowflake"

    const [loading, setLoading] = useState(true);

    const [stacklineWeekOptions, setStacklineWeekOptions] = useState([]);
    const [startWeekId, updateStartWeekId] = useState(undefined);
    const [endWeekId, updateEndWeekId] = useState(undefined);

    React.useEffect(() => {
        setLoading(true);
        Promise.all([
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/timeService`),
        ])
            .then(([
                       timeServiceResults
                   ]) => {

                const stacklineWeeksMapped = timeServiceResults.data.map(weeks => {
                    const spinsWeek = weeks.spinsWeek.toString();
                    const year = spinsWeek.substring(0, 4);
                    const weekNumber = spinsWeek.substring(spinsWeek.length - 2);
                    const stacklineWeek = parseInt(year + weekNumber)
                    return {label: stacklineWeek, value: stacklineWeek};
                })
                setStacklineWeekOptions(_.sortBy(stacklineWeeksMapped, ['label']).reverse())
                setLoading(false);
            })
            .catch((error) => {
                console.error(error)
                setLoading(false);
            })
            .finally(() => setLoading(false))

    }, []);


    const triggerDag = () => {
        const data = {
            stackline_start_week_id: startWeekId,
            stackline_end_week_id: endWeekId
        };
        return invokeDAGviaApiPost(DAG_ID_TO_TRIGGER_FOR_SALES, data);
    };

    const isSubmitButtonDisabled = () => !startWeekId || !endWeekId;

    return (
        <div className={'stackline-data-unload'}>
                <LoadingWrapper loading={loading}>
                    <div className={'stackline-action-buttons-container'}>
                        <div className={'stackline-column'}>
                            <div className={'stackline-weeks-selection-row'}>
                                <SelectDropdown
                                    id={'start_week_dropdown'}
                                    dataTestId={'start_week_dropdown'}
                                    inputLabel={"Start Week"}
                                    onChange={(option) => updateStartWeekId(option.value)}
                                    selectValue={startWeekId}
                                    options={stacklineWeekOptions}
                                    placeholder={'Select Start Week...'}
                                />
                                <SelectDropdown
                                    id={'end_week_dropdown'}
                                    dataTestId={'end_week_dropdown'}
                                    inputLabel={"End Week"}
                                    onChange={(option) => updateEndWeekId(option.value)}
                                    selectValue={endWeekId}
                                    options={stacklineWeekOptions}
                                    placeholder={'Select End Week...'}
                                />
                            </div>
                        </div>
                        <div className={'stackline-column'}>
                            <div className={'stackline-trigger-dag-row'}>
                                <ButtonLoader
                                    buttonTitle={"Trigger Dag"}
                                    buttonHasModal
                                    buttonClassName={"button primary "}
                                    modalHeader={"Confirm Trigger Unload"}
                                    modalText={`Are you sure you want to trigger ${DAG_ID_TO_TRIGGER_FOR_SALES}?`}
                                    axiosFunction={() => triggerDag()}
                                    disabled={isSubmitButtonDisabled()}
                                    toastTextFailure={`${DAG_ID_TO_TRIGGER_FOR_SALES} DAG trigger failed with error`}
                                    toastTextSuccess={`${DAG_ID_TO_TRIGGER_FOR_SALES} DAG triggered successfully!  Refresh the page to see current status.`}
                                />
                            </div>
                        </div>
                    </div>
                </LoadingWrapper>
                <br/>
                <AirflowDagLogs
                    processName={DAG_ID_TO_TRIGGER_FOR_SALES}
                    includeDagName={false}
                    customColumns={[
                        {
                            header: 'Start Week Id',
                            accessorKey: 'conf.stackline_start_week_id',
                            className: 'non-numeric-field'
                        },
                        {
                            header: 'End Week Id',
                            accessorKey: 'conf.stackline_end_week_id',
                            className: 'non-numeric-field'
                        }
                    ]}
                />
        </div>
    );
};

StacklineDataUnload.propTypes = {};

export default StacklineDataUnload;